import { h } from "@stencil/core";
import { simpleModel1, simpleModel2 } from "./models";
import { renderShowcaseProperties, updateShowcase } from "../utils";
const state = {};
const formRefs = {
    "form-radio-group-1": undefined,
    "form-radio-group-2": undefined,
    "form-radio-group-3": undefined
};
const formValues = {
    "radio-group-1": "",
    "radio-group-2": "",
    "radio-group-3": ""
};
const handleValueInput = (formId, switchId) => () => {
    formValues[switchId] = Object.fromEntries(new FormData(formRefs[formId]))[switchId];
    // TODO: Until we support external slots in the ch-flexible-layout-render,
    // this is a hack to update the render of the widget and thus re-render the
    // combo-box updating the displayed items
    updateShowcase();
};
const render = () => (h("div", { class: "radio-group-test-main-wrapper" }, h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "No label"), h("form", { id: "form-radio-group-1", ref: el => (formRefs["form-radio-group-1"] = el) }, h("ch-radio-group-render", { id: "radio-group-1",
    // name="radio-group-1"
    class: "radio-group", direction: state.direction, disabled: state.disabled, model: state.model, value: state.value, onInput: handleValueInput("form-radio-group-1", "radio-group-1") })), "Form value: ", formValues["radio-group-1"]), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Label with HTML for"), h("form", { id: "form-radio-group-2", ref: el => (formRefs["form-radio-group-2"] = el) }, h("label", { class: "label", htmlFor: "radio-group-2" }, "Label for switch 2"), h("ch-radio-group-render", { id: "radio-group-2",
    // name="radio-group-2"
    class: "radio-group", direction: state.direction, disabled: state.disabled, model: state.model, value: state.value, onInput: handleValueInput("form-radio-group-2", "radio-group-2") })), "Form value: ", formValues["radio-group-2"]), h("fieldset", { class: "fieldset-test" }, h("legend", { class: "heading-4 field-legend-test" }, "Component inside label"), h("form", { id: "form-radio-group-3", ref: el => (formRefs["form-radio-group-3"] = el) }, h("label", { class: "label", htmlFor: "radio-group-3" }, "Label for switch 3", h("ch-radio-group-render", { id: "radio-group-3",
    // name="radio-group-3"
    class: "radio-group", direction: state.direction, disabled: state.disabled, model: state.model, value: state.value, onInput: handleValueInput("form-radio-group-3", "radio-group-3") }))), "Form value: ", formValues["radio-group-3"])));
const showcaseRenderProperties = [
    {
        caption: "Models",
        properties: [
            {
                id: "model",
                accessibleName: "Model",
                type: "enum",
                values: [
                    { caption: "Simple Model", value: simpleModel1 },
                    { caption: "Simple Model 2", value: simpleModel2 }
                ],
                value: simpleModel2
            }
        ]
    },
    {
        caption: "Properties",
        properties: [
            {
                id: "value",
                caption: "Value",
                value: undefined,
                type: "string"
            },
            {
                id: "direction",
                caption: "Direction",
                value: "horizontal",
                values: [
                    { caption: "Horizontal", value: "horizontal" },
                    { caption: "Vertical", value: "vertical" }
                ],
                render: "radio-group",
                type: "enum"
            },
            {
                id: "disabled",
                caption: "Disabled",
                value: false,
                type: "boolean"
            }
        ]
    }
];
const showcasePropertiesInfo = [
    { name: "class", fixed: true, value: "radio-group", type: "string" },
    { name: "direction", defaultValue: "horizontal", type: "string" },
    { name: "disabled", defaultValue: false, type: "boolean" },
    { name: "model", fixed: true, value: "controlUIModel", type: "function" },
    { name: "value", defaultValue: undefined, type: "string" },
    {
        name: "input",
        fixed: true,
        value: "handleInput",
        type: "event"
    }
];
export const radioGroupShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithUIModel: {
        uiModel: () => state.model,
        uiModelType: "RadioGroupModel",
        render: {
            react: () => `<ChRadioGroupRender${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      ></ChRadioGroupRender>`,
            stencil: () => `<ch-radio-group-render${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        ></ch-radio-group-render>`
        }
    },
    render: render,
    state: state
};
